import { useEffect, useState, useRef, useLayoutEffect, useCallback } from 'react'
import { debounce } from 'lodash'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Popover from 'react-bootstrap/Popover'
import { PageLink, PageTitle } from '../../_metronic/layout/core'
import { getDailySales } from '../apis/Loadalltabledata'
import { KTCard } from '../../_metronic/helpers'
import { KTCardBody } from '../../_metronic/helpers'
import { KTSVG, toAbsoluteUrl } from '../../_metronic/helpers'
import { Maintable } from '../tables/Maintable'
import { useMemo } from 'react'
import LoadingBar from 'react-top-loading-bar'
import { useDashboard } from '../contextProviders/Dashboardcontext'
import { useWindowWidth } from '@react-hook/window-size/throttled'
import {
  useSalesInvoicesusequeryprofitloss,
  useDailysalesquery,
  useDailysalesquery2,
  useGrossprofitorlossusequery2,
} from '../contextProviders/Atomqueryprovider'
import CountUp from 'react-countup'
import '../css/popover.css'
import { Column } from 'react-table'
import { useAuth } from '../../app/modules/auth'
import { ItemsSummary } from '../topdashboard/ItemsSummary'
import { useMutation, useQueryClient } from 'react-query'
import io from 'socket.io-client'
import { Getfirsttwowords, Getnumbersinstring } from '../helpers/useStringhelper'

import useNumberSequence from '../helpers/useKeySequence'
import useAggregatedData from '../helpers/useAggregatedData'
import useDataTrend from '../helpers/useDataTrend'

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone'
import relativeTime from 'dayjs/plugin/relativeTime'
import calendar from 'dayjs/plugin/calendar'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import isBetween from 'dayjs/plugin/isBetween';
import { Dailysummarymodal } from './modals/Dailysummarymodal'

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime)
dayjs.extend(calendar)
dayjs.extend(localizedFormat)
dayjs.extend(isBetween);


const CURRENCY_APP = process.env.REACT_APP_CURRENCY
const OPENING_TIME = process.env.REACT_APP_OPENING_TIME
const PIC_QUANTITIES = process.env.REACT_APP_QUANTITIES_PICS
// Hook

const usersBreadcrumbs: Array<PageLink> = [
  {
    title: 'Dashboard',
    path: '/home',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]


const addCommas = (num: any) => {
  // Handle undefined, null, or non-numeric values
  if (num === undefined || num === null || num === '') {
    return '0'
  }
  
  // Convert to number if it's a string
  const numValue = typeof num === 'string' ? parseFloat(num) : num
  
  // Check if it's a valid number
  if (isNaN(numValue)) {
    return '0'
  }
  
  return numValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
const socket = io('possocket.27mirrors.com')
const truncate = require('truncate')
const isNegative = (num: any) => Math.sign(num) === -1

const Home = () => {
  const refloadingbar: any = useRef(null)
  const queryClient = useQueryClient()
  const myRefsearch: any = useRef()
  const { currentUser, logout } = useAuth()
  const [paginationsize, setPaginationsize] = useState<number>(10)
  const [startlimit, setStartlimit] = useState<number>(0)
  const [statusnow, setStatusnow] = useState<boolean>(false)
  const [statusnow2, setStatusnow2] = useState<boolean>(false)
  const [itemto_order, setItemto_order] = useState<string>('datesoldnow')
  const [desorasc, setDesorasc] = useState<string>('DESC')
  const [serversort, setServersort] = useState<any>([])
  const [search_item, setSearch_item] = useState<string>('%')
  const [pageCount, setPageCount] = useState<number>(0)
  const [sumsalesdatanew, setSumsalesdatanew] = useState<any>([])
  const [showDailySummary, setShowDailySummary] = useState<boolean>(false)
  const myRefdailysummary: any = useRef()
  const [selectedRowData, setSelectedRowData] = useState<any>(null)
  const { showDashboard, toggleDashboard } = useDashboard();

  const [selectedDateForModal, setSelectedDateForModal] = useState<string>(dayjs().format('YYYY-MM-DD'))
  const [hiddencolumnsmade, setHiddencolumnsmade] = useState<any>([
    'date_end',
    'payment_totals',
    'sales_info',
    'total_expenses',
    'total_opening_float',
    'total_closing_float'
  ])

  const [hiddencolumnsmade2, setHiddencolumnsmade2] = useState<any>([
    'date_end',
    'payment_totals',
    'sales_info',
    'total_expenses',
    'total_opening_float',
    'total_closing_float',
    'net_sales'
  ])
  const onlyWidth = useWindowWidth()
  const [movetofirstpage, setMovetofirstpage] = useState<boolean>(false)

  const netsales: any = useAggregatedData(
    sumsalesdatanew
      .sort((a: any, b: any) => (a.datesoldnow > b.datesoldnow ? -1 : 1))
      .map((item: any) => ({
        datesoldnow: item.datesoldnow,
        occurrences: item.occurrences,
        hours_selling: item.hours_selling,
        totals: item.net_sales,
      }))
  ).map((x: any) => x.totals_sum)
const handleCloseDailySummary = () => {
  setShowDailySummary(false)
  setSelectedRowData(null) // Clear the selected row data
  myRefdailysummary.current.resetModalValues()
}

const handleShowDailySummary = () => {
  setShowDailySummary(true)
}
  const netsales2: any = useAggregatedData(
    sumsalesdatanew
      .sort((a: any, b: any) => (a.datesoldnow > b.datesoldnow ? 1 : -1))
      .map((item: any) => ({
        datesoldnow: item.datesoldnow,
        occurrences: item.occurrences,
        hours_selling: item.hours_selling,
        totals: item.net_sales,
      }))
  ).map((x: any) => x.totals_sum)

  const gross_sales: any = useAggregatedData(
    sumsalesdatanew
      .sort((a: any, b: any) => (a.datesoldnow > b.datesoldnow ? -1 : 1))
      .map((item: any) => ({
        datesoldnow: item.datesoldnow,
        occurrences: item.occurrences,
        hours_selling: item.hours_selling,
        totals: item.gross_sales,
      }))
  ).map((x: any) => x.totals_sum)

  const gross_sales2: any = useAggregatedData(
    sumsalesdatanew
      .sort((a: any, b: any) => (a.datesoldnow > b.datesoldnow ? 1 : -1))
      .map((item: any) => ({
        datesoldnow: item.datesoldnow,
        occurrences: item.occurrences,
        hours_selling: item.hours_selling,
        totals: item.gross_sales,
      }))
  ).map((x: any) => x.totals_sum)

  const gross_sales_date: any = useAggregatedData(
    sumsalesdatanew
      .sort((a: any, b: any) => (a.datesoldnow > b.datesoldnow ? -1 : 1))
      .map((item: any) => ({
        datesoldnow: item.datesoldnow,
        occurrences: item.occurrences,
        hours_selling: item.hours_selling,
        totals: item.gross_sales,
      }))
  ).map((x: any) => x.month)

  const gross_sales_date2: any = useAggregatedData(
    sumsalesdatanew
      .sort((a: any, b: any) => (a.datesoldnow > b.datesoldnow ? 1 : -1))
      .map((item: any) => ({
        datesoldnow: item.datesoldnow,
        occurrences: item.occurrences,
        hours_selling: item.hours_selling,
        totals: item.gross_sales,
      }))
  ).map((x: any) => x.month + ', ' + x.year)

  const sales_date: any = useAggregatedData(
    sumsalesdatanew
      .sort((a: any, b: any) => (a.datesoldnow > b.datesoldnow ? -1 : 1))
      .map((item: any) => ({
        datesoldnow: item.datesoldnow,
        occurrences: item.occurrences,
        hours_selling: item.hours_selling,
        totals: item.net_sales,
      }))
  ).map((x: any) => x.month)

  const sales_date2: any = useAggregatedData(
    sumsalesdatanew
      .sort((a: any, b: any) => (a.datesoldnow > b.datesoldnow ? 1 : -1))
      .map((item: any) => ({
        datesoldnow: item.datesoldnow,
        occurrences: item.occurrences,
        hours_selling: item.hours_selling,
        totals: item.net_sales,
      }))
  ).map((x: any) => x.month + ', ' + x.year)

  const deductions_made: any = useAggregatedData(
    sumsalesdatanew
      .sort((a: any, b: any) => (a.datesoldnow > b.datesoldnow ? -1 : 1))
      .map((item: any) => ({
        datesoldnow: item.datesoldnow,
        occurrences: item.occurrences,
        hours_selling: item.hours_selling,
        totals: item.gross_deductions,
      }))
  ).map((x: any) => x.totals_sum)

  const discounts_made2: any = useAggregatedData(
    sumsalesdatanew
      .sort((a: any, b: any) => (a.datesoldnow > b.datesoldnow ? 1 : -1))
      .map((item: any) => ({
        datesoldnow: item.datesoldnow,
        occurrences: item.occurrences,
        hours_selling: item.hours_selling,
        totals: item.gross_deductions,
      }))
  ).map((x: any) => x.totals_sum)

  const discounts_made_date: any = useAggregatedData(
    sumsalesdatanew
      .sort((a: any, b: any) => (a.datesoldnow > b.datesoldnow ? -1 : 1))
      .map((item: any) => ({
        datesoldnow: item.datesoldnow,
        occurrences: item.occurrences,
        hours_selling: item.hours_selling,
        totals: item.gross_deductions,
      }))
  ).map((x: any) => x.month)

  const discounts_made_date2: any = useAggregatedData(
    sumsalesdatanew
      .sort((a: any, b: any) => (a.datesoldnow > b.datesoldnow ? 1 : -1))
      .map((item: any) => ({
        datesoldnow: item.datesoldnow,
        occurrences: item.occurrences,
        hours_selling: item.hours_selling,
        totals: item.gross_deductions,
      }))
  ).map((x: any) => x.month + ', ' + x.year)



  const {
    isLoading: dailysalesisloading,
    isSuccess: dailysalesssuccess,
    data: dailysalesdata,
    isPreviousData: dailysalesispreviousdata,
    isRefetching: dailysalesrefetching,
    status: dailysalesstatus,
    refetch: dailysalesrefetch,
  } = useDailysalesquery(
    Number(currentUser?.user_id),
    'PAID',
    new Date(dayjs
      .unix(dayjs(dayjs().startOf('year').format('YYYY-MM-DD') + OPENING_TIME).unix())
      .format('YYYY-MM-DD hh:mm')),
    new Date(dayjs
      .unix(dayjs(dayjs().endOf('year').format('YYYY-MM-DD') + OPENING_TIME).unix())
      .format('YYYY-MM-DD hh:mm')),
    startlimit,
    paginationsize,
    itemto_order,
    desorasc,
    search_item
  )

  const {
    isLoading: dailysalesisloading2,
    isSuccess: dailysalesssuccess2,
    data: dailysalesdata2,
    isPreviousData: dailysalesispreviousdata2,
    isRefetching: dailysalesrefetching2,
    status: dailysalesstatus2,
    refetch: dailysalesrefetch2,
  } = useDailysalesquery2(
    Number(currentUser?.user_id),
    'PAID',
    new Date(dayjs
      .unix(dayjs(dayjs().startOf('year').format('YYYY-MM-DD') + OPENING_TIME).unix())
      .format('YYYY-MM-DD hh:mm')),
    new Date(dayjs
      .unix(dayjs(dayjs().endOf('year').format('YYYY-MM-DD') + OPENING_TIME).unix())
      .format('YYYY-MM-DD hh:mm')),
    0,
    366,
    'datesoldnow',
    'DESC',
    '%'
  )

  const tabledata = useMemo(
    () => dailysalesdata?.data.dailysales,
    [dailysalesdata?.data.dailysales, dailysalesssuccess]
  )
  const tabledata2 = useMemo(
    () => dailysalesdata?.data.dailysales
      .map((x: any) => x.sales_info)
      .flatMap((x: any) => x)
      .filter((item: any) => item !== null && item !== undefined) // Filter out null/undefined
      .sort((a: any, b: any) => (a.datesold > b.datesold ? -1 : 1)),
    [dailysalesdata?.data.dailysales, dailysalesssuccess]
  )

  const tabledata3 = useMemo(
    () => dailysalesdata2?.data.dailysales,
    [dailysalesdata2?.data.dailysales, dailysalesssuccess2]
  )
  const tabledatalength = useMemo(
    () => dailysalesdata?.data.datalength,
    [dailysalesdata?.data.datalength, dailysalesssuccess]
  )

  const tablename = 'Sales Summary'

  const filteredsubdata = (rowdata: any): number => {
    return rowdata.values.sales_info.length
  }
  const filteredtablesubData = (rowdata: any): any => {
    return rowdata.values.sales_info
  }


  const paymenttypedetails = (rowdata: any): any => {
    return rowdata.values.payment_totals
  }



  const salesTrend = useDataTrend(tabledata3)

  useEffect(() => {
    if (!dailysalesrefetching2 && dailysalesssuccess2) {
      if (
        dayjs(
          dayjs(
            dailysalesdata2?.data.dailysales
              .sort((a: any, b: any) => (a.datesoldnow > b.datesoldnow ? -1 : 1))
              .map((x: any) => x.datesoldnow)[0]
          ).format('YYYY-MM-DD')
        ).unix() === dayjs(dayjs().format('YYYY-MM-DD')).unix()
      ) {
        setSumsalesdatanew(dailysalesdata2?.data.dailysales)
      } else {
        if (
          dayjs(
            dayjs(
              dailysalesdata2?.data.dailysales
                .sort((a: any, b: any) => (a.datesoldnow > b.datesoldnow ? -1 : 1))
                .map((x: any) => x.datesoldnow)[0]
            ).format('YYYY-MM-DD')
          ).unix() === dayjs(dayjs().subtract(1, 'days').format('YYYY-MM-DD')).unix() &&
          dayjs(dayjs().format('YYYY-MM-DD, h:mm:ss a')).unix() <=
          dayjs(dayjs().format('YYYY-MM-DD') + OPENING_TIME).unix()
        ) {
          setSumsalesdatanew(dailysalesdata2?.data.dailysales)
        } else {
          const currentitemsobj2: any = {
            datesoldnow: dayjs().format('YYYY-MM-DD'),
            date_start: dayjs().format('YYYY-MM-DD'),
            date_end: dayjs().format('YYYY-MM-DD'),
            occurrences: 0,
            hours_selling: 0,
            gross_sales: 0,
            gross_deductions: 0,
            net_sales: 0,
            total_mpesa: 0,
            total_cash: 0,
            total_cheque: 0,
            total_bank_transfer: 0,
          }
          setSumsalesdatanew([...dailysalesdata2?.data.dailysales, currentitemsobj2])
        }
      }
    }
  }, [dailysalesrefetching2, dailysalesssuccess2])

  useEffect(() => {
    if (dailysalesssuccess2) {
      setStatusnow(true)
    } else {
      setStatusnow(false)
    }
  }, [dailysalesssuccess2])

  useEffect(() => {
    if (statusnow && !dailysalesrefetching2) {
      setStatusnow2(true)
    } else {
      setStatusnow2(false)
    }
  }, [dailysalesrefetching2])

  useEffect(() => {
    if (!dailysalesispreviousdata) {
      ; (async () => {
        await refloadingbar.current?.continuousStart()
        queryClient.prefetchQuery(
          ['dailysalesusequery', startlimit + paginationsize, paginationsize],
          () =>
            getDailySales(
              Number(currentUser?.user_id),
              'PAID',
              new Date(dayjs
                .unix(dayjs(dayjs().startOf('year').format('YYYY-MM-DD') + OPENING_TIME).unix())
                .format('YYYY-MM-DD hh:mm')),
              new Date(dayjs
                .unix(dayjs(dayjs().endOf('year').format('YYYY-MM-DD') + OPENING_TIME).unix())
                .format('YYYY-MM-DD hh:mm')),
              startlimit + paginationsize,
              paginationsize,
              itemto_order,
              desorasc,
              search_item
            )
        )
      })().finally(refloadingbar.current.complete())
    }
  }, [
    dailysalesispreviousdata,
    startlimit,
    paginationsize,
    queryClient,
    itemto_order,
    desorasc,
    search_item,
  ])

  useEffect(() => {
    const fetchData = async () => {
      try {
        await refloadingbar.current?.continuousStart();
        await dailysalesrefetch();
      } catch (error) {
        console.log(error)
      } finally {
        refloadingbar.current.complete();
      }
    };
    fetchData();
  }, [itemto_order, desorasc, search_item]);



  useEffect(() => {
    const handleValueChange = () => {
      if (myRefsearch.current.value === '' && myRefsearch.current === document.activeElement) {
        setSearch_item('%')
        setPaginationsize(10)
        setStartlimit(0)
        setMovetofirstpage(true)
        setItemto_order('datesoldnow')
        setDesorasc('DESC')
      }
    }

    const refSearch = myRefsearch.current;
    if (refSearch) {
      refSearch.addEventListener('input', handleValueChange);
    }

    return () => {
      if (refSearch) {
        refSearch.removeEventListener('input', handleValueChange);
      }
    }
  }, []);

  useEffect(() => {
    if (serversort.length > 0) {
      setItemto_order(serversort.map((x: any) => x.id)[0])
      setDesorasc(serversort.map((x: any) => x.desc)[0] ? 'DESC' : 'ASC')
    } else {
      setItemto_order('datesoldnow')
      setDesorasc('DESC')
    }
  }, [serversort])

  const handlesearchKeyDown = (event: any) => {
    if (event.key === 'Enter') {
      const inputValue = event.target.value;
      if (inputValue) {
        setSearch_item(inputValue + '%');
      } else {
        setSearch_item('%');
      }
      setPaginationsize(10)
      setStartlimit(0)
      setMovetofirstpage(true)
      setItemto_order('datesoldnow')
      setDesorasc('DESC')
    }
  };

  const handleinputs = (event: any) => {
    if (myRefsearch.current.value === '' || event.target.value === '') {
      setSearch_item('%')
      setPaginationsize(10)
      setStartlimit(0)
      setMovetofirstpage(true)
      setItemto_order('datesoldnow')
      setDesorasc('DESC')
    }
  }

  const handlesearchKeyDown2 = (event: any) => {
    event.preventDefault()
    const inputValue = myRefsearch.current.value || event.target.value;

    if (inputValue) {
      setSearch_item(inputValue + '%');
    } else {
      setSearch_item('%');
    }

    setPaginationsize(10)
    setStartlimit(0)
    setMovetofirstpage(true)
    setItemto_order('datesoldnow')
    setDesorasc('DESC')
  }

  socket.on('update', (_arg: any) => {
    ; (async () => {
      try {
        await refloadingbar.current?.continuousStart()
        await dailysalesrefetch2()
        await dailysalesrefetch()

      } catch (error) {
        console.log(error)
      } finally {
        await refloadingbar.current?.complete()
      }
    })()
  })


  const columndata1: ReadonlyArray<
    Column<{
      datesoldnow: string
      date_start: string
      date_end: string
      occurrences: number
      hours_selling: number
      sales_tax: number
      net_sales: number
      gross_sales: number
      discount: number
      gross_deductions: number
      sales_trend: number
      payment_totals:Array<number | string>
      sales_info: Array<number | string>
      total_opening_float: number
      total_closing_float: number
      total_expenses: number
    }>
  > = [
      {
        Header: () => null,
        id: 'expander',

        Cell: ({ row }: any) => {
          return (
            <span {...row.getToggleRowExpandedProps()}>
              {row.isExpanded ? (
                <>
                  <span className='svg-icon svg-icon-primary'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      xmlnsXlink='http://www.w3.org/1999/xlink'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                    >
                      <g fill='none' fillRule='evenodd'>
                        <path d='M0 0L24 0 24 24 0 24z'></path>
                        <path
                          fill='#009ef7'
                          fillRule='nonzero'
                          d='M17.293 8.293a1 1 0 111.414 1.414l-6 6a1 1 0 01-1.383.03l-6-5.5a1 1 0 111.352-1.474l5.294 4.853 5.323-5.323z'
                        ></path>
                      </g>
                    </svg>
                  </span>
                </>
              ) : (
                <>
                  <span className='svg-icon svg-icon-primary'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      xmlnsXlink='http://www.w3.org/1999/xlink'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                    >
                      <g fill='none' fillRule='evenodd'>
                        <path d='M0 0L24 0 24 24 0 24z'></path>
                        <path
                          fill='#009ef7'
                          fillRule='nonzero'
                          d='M8.293 6.707a1 1 0 111.414-1.414l6 6a1 1 0 01.03 1.383l-5.5 6a1 1 0 11-1.474-1.352l4.853-5.294-5.323-5.323z'
                        ></path>
                      </g>
                    </svg>
                  </span>
                </>
              )}
            </span>
          )
        },
      },
      {
        Header: 'Date',
        accessor: 'date_start', // accessor is the "key" in the data

        Cell: ({ cell: { value }, row }) => {
          return (
            <div className='d-flex align-items-center'>
              <div className='symbol symbol-60px me-5'>
                <span className='svg-icon svg-icon-primary svg-icon-3x'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='20'
                    height='21'
                    fill='none'
                    viewBox='0 0 20 21'
                  >
                    <path
                      fill='currentColor'
                      d='M19 3.4c-.6 0-1 .4-1 1v4h-4v-4c0-.6-.4-1-1-1s-1 .4-1 1v4H8v-4c0-.6-.4-1-1-1s-1 .4-1 1v4H2v-4c0-.6-.4-1-1-1s-1 .4-1 1v15c0 .6.4 1 1 1h18c.6 0 1-.4 1-1v-15c0-.6-.4-1-1-1zm-1 7v3h-4v-3h4zm-6 0v3H8v-3h4zm0 5v3H8v-3h4zm-6-5v3H2v-3h4zm-4 5h4v3H2v-3zm12 3v-3h4v3h-4z'
                      opacity='0.3'
                    ></path>
                    <path
                      fill='currentColor'
                      d='M19 .4H1c-.6 0-1 .4-1 1v3c0 .6.4 1 1 1h18c.6 0 1-.4 1-1v-3c0-.6-.4-1-1-1z'
                    ></path>
                  </svg>
                </span>
              </div>

              <div className='d-flex justify-content-start flex-column'>
                <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6'>
                  {dayjs(value).format('MMMM')} {dayjs(value).format('DD')} -{' '}
                  {dayjs(row.original.date_end).format('DD')} , {dayjs(value).format('YYYY')}
                </span>
                <span className='text-muted  text-nowrap fw-bold text-muted d-block fs-7'>
                  {dayjs(value).format('LTS')} - {dayjs(row.original.date_end).format('LTS')}
                </span>
              </div>
            </div>
          )
        },
      },

      {
        Header: 'E.Sales',
        accessor: 'date_end',

        Cell: ({ cell: { value } }) => (
          <>
            <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6'>
              {dayjs(value).format('LL')}
            </span>
            <span className='text-muted  text-nowrap fw-bold text-muted d-block fs-7'>
              {dayjs(value).format('dddd')}, {dayjs(value).format('LTS')}
            </span>
          </>
        ),
      },

      {
        Header: 'Entries',
        accessor: 'occurrences',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6'>{value}</span>
            <span className='text-muted  text-nowrap fw-bold text-muted d-block fs-7'>
              {row.original.hours_selling} Hours
            </span>
          </>
        ),
      },

      {
        Header: 'G.Sales',
        accessor: 'gross_sales',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6'>
              <>
                {isNegative(value) ? (
                  <span className='text-danger'>
                    {addCommas(value.toFixed(2))} {CURRENCY_APP}
                  </span>
                ) : (
                  <span>
                    {addCommas(value.toFixed(2))} {CURRENCY_APP}{' '}
                  </span>
                )}
              </>
            </span>
            <span className='text-nowrap fw-bold text-muted d-block fs-7'>
              <span className='badge badge-light-danger'>
                {addCommas(row.original.gross_deductions.toFixed(2))} {CURRENCY_APP}
              </span>
            </span>
          </>
        ),
      },
      
      {
        Header: 'sales_info',
        accessor: 'sales_info',

      },
      {
        Header: 'payment_totals',
        accessor: 'payment_totals',
      },
      {
        Header: 'total_expenses',
        accessor: 'total_expenses',
      },

       {
        Header: 'total_opening_float',
        accessor: 'total_opening_float',
      },

       {
        Header: 'total_closing_float',
        accessor: 'total_closing_float',
      },
      {
        Header: 'N.Sales',
        accessor: 'net_sales',

        Cell: ({ cell: { value }, row }) => (
          <>
            {isNegative(value) ? (
              <span className='text-nowrap'>
                {isNegative(row.original.sales_trend) ? (
                  <i className='fa fa-arrow-down text-danger'></i>
                ) : row.original.sales_trend === 0 ? (
                  <i className='fa fa-arrow-up text-primary'></i>
                ) : (
                  <i className='fa fa-arrow-up text-success'></i>
                )}{' '}
                <span className='badge badge-light-danger'>
                  <span className='text-nowrap fs-7'>
                    {' '}
                    {addCommas(value.toFixed(2))} {CURRENCY_APP}
                  </span>
                </span>
              </span>
            ) : (
              <span className='text-nowrap'>
                {isNegative(row.original.sales_trend) ? (
                  <i className='fa fa-arrow-down text-danger'></i>
                ) : row.original.sales_trend === 0 ? (
                  <i className='fa fa-arrow-up text-primary'></i>
                ) : (
                  <i className='fa fa-arrow-up text-success'></i>
                )}{' '}
                <span className='badge badge-light-success'>
                  <span className='text-nowrap fs-7'>
                    {' '}
                    {addCommas(value.toFixed(2))} {CURRENCY_APP}
                  </span>
                </span>
              </span>
            )}
          </>
        ),
      },
{
  Header: '',
  accessor: 'datesoldnow',
  Cell: ({ cell: { value }, row }) => (
    <button
      type='button'
      className='btn btn-sm btn-light-primary'
      onClick={() => {
        setSelectedDateForModal(value)
        setSelectedRowData(row.original)
        handleShowDailySummary()
      }}
      title={`View summary for ${dayjs(value).format('MMMM DD, YYYY')}`}
    >
      <span className='svg-icon svg-icon-3'>
        <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
          <path d='M17.5 11H6.5C4 11 2 9 2 6.5C2 4 4 2 6.5 2H17.5C20 2 22 4 22 6.5C22 9 20 11 17.5 11ZM15 6.5C15 7.9 16.1 9 17.5 9C18.9 9 20 7.9 20 6.5C20 5.1 18.9 4 17.5 4C16.1 4 15 5.1 15 6.5Z' fill='currentColor'/>
          <path opacity='0.3' d='M17.5 22H6.5C4 22 2 20 2 17.5C2 15 4 13 6.5 13H17.5C20 13 22 15 22 17.5C22 20 20 22 17.5 22ZM4 17.5C4 18.9 5.1 20 6.5 20C7.9 20 9 18.9 9 17.5C9 16.1 7.9 15 6.5 15C5.1 15 4 16.1 4 17.5Z' fill='currentColor'/>
        </svg>
      </span>
      Summary
    </button>
  ),
},
]
  const columndata2: ReadonlyArray<
    Column<{
      sales_id: number
      quantity: number
      unit_price: number
      sub_total: number
      product_id: number
      discount_percentage: number
      product_unit_id: number
      user_id: number
      sales_invoice_id: string
      datesold: string
      sales_status: string
      product_name: string
      unit_name: string
    }>
  > = [
      {
        Header: 'Salesid',
        accessor: 'sales_id',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-dark text-nowrap  fw-bolder d-block mb-1 fs-6'>{value}</span>
          </>
        ),
      },
      {
        Header: 'Product',
        accessor: 'product_id',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-primary text-nowrap  fw-bolder d-block mb-1 fs-6'>
              {truncate(row.original.product_name, 20)}
            </span>

            <span className='text-muted  text-nowrap  fw-bold text-muted d-block fs-7'>{value}</span>
          </>
        ),
      },

      {
        Header: 'Quantity',
        accessor: 'quantity',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-dark text-nowrap  fw-bolder d-block mb-1 fs-6'>{value}</span>
            <span className='text-muted  text-nowrap  fw-bold text-muted d-block fs-7'>
              {row.original.unit_name}
            </span>
          </>
        ),
      },

      {
        Header: 'Price',
        accessor: 'unit_price',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-dark text-nowrap  fw-bolder d-block mb-1 fs-6'>
              {addCommas(value.toFixed(2))} {CURRENCY_APP}
            </span>

            <span className='text-muted  text-nowrap  fw-bold text-muted d-block fs-7'>
              {row.original.discount_percentage}% OFF
            </span>
          </>
        ),
      },
      {
        Header: 'Total',
        accessor: 'sub_total',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-success text-nowrap  fw-bolder d-block mb-1 fs-6'>
              {addCommas(value.toFixed(2))} {CURRENCY_APP}
            </span>
          </>
        ),
      },
    ]

  // less than 420

  const columndata3: ReadonlyArray<
    Column<{
      datesoldnow: string
      date_start: string
      date_end: string
      occurrences: number
      hours_selling: number
      sales_tax: number
      net_sales: number
      gross_sales: number
      discount: number
      gross_deductions: number
      sales_trend: number
      payment_totals:Array<number | string>
      sales_info: Array<number | string>
      total_opening_float: number
      total_closing_float: number
      total_expenses: number
    }>
  > = [
      {
        Header: () => null,
        id: 'expander',

        Cell: ({ row }: any) => {
          return (
            <span {...row.getToggleRowExpandedProps()}>
              {row.isExpanded ? (
                <>
                  <span className='svg-icon svg-icon-primary'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      xmlnsXlink='http://www.w3.org/1999/xlink'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                    >
                      <g fill='none' fillRule='evenodd'>
                        <path d='M0 0L24 0 24 24 0 24z'></path>
                        <path
                          fill='#009ef7'
                          fillRule='nonzero'
                          d='M17.293 8.293a1 1 0 111.414 1.414l-6 6a1 1 0 01-1.383.03l-6-5.5a1 1 0 111.352-1.474l5.294 4.853 5.323-5.323z'
                        ></path>
                      </g>
                    </svg>
                  </span>
                </>
              ) : (
                <>
                  <span className='svg-icon svg-icon-primary'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      xmlnsXlink='http://www.w3.org/1999/xlink'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                    >
                      <g fill='none' fillRule='evenodd'>
                        <path d='M0 0L24 0 24 24 0 24z'></path>
                        <path
                          fill='#009ef7'
                          fillRule='nonzero'
                          d='M8.293 6.707a1 1 0 111.414-1.414l6 6a1 1 0 01.03 1.383l-5.5 6a1 1 0 11-1.474-1.352l4.853-5.294-5.323-5.323z'
                        ></path>
                      </g>
                    </svg>
                  </span>
                </>
              )}
            </span>
          )
        },
      },
      {
        Header: 'Date',
        accessor: 'date_start', // accessor is the "key" in the data

        Cell: ({ cell: { value }, row }) => {
          return (
            <div className='d-flex align-items-center'>
              <div className='d-flex justify-content-start flex-column'>
                <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6'>
                  {dayjs(value).format('MMM')} {dayjs(value).format('DD')} -{' '}
                  {dayjs(row.original.date_end).format('DD')} , {dayjs(value).format('YYYY')}
                </span>
                <span className='text-muted  text-nowrap fw-bold text-muted d-block fs-7'>
                  {dayjs(value).format('LT')} - {dayjs(row.original.date_end).format('LT')}
                </span>
                <span>
          {isNegative(Number(row.original.net_sales)) ? (
            <span className='text-nowrap'>
              {isNegative(row.original.sales_trend) ? (
                <i className='fa fa-arrow-down text-danger'></i>
              ) : row.original.sales_trend === 0 ? (
                <i className='fa fa-arrow-up text-primary'></i>
              ) : (
                <i className='fa fa-arrow-up text-success'></i>
              )}{' '}
              <span className='badge badge-light-danger'>
                <span className='text-nowrap fs-7'>
                  {' '}
                  Net Sales: {addCommas(row.original.net_sales.toFixed(2))} {CURRENCY_APP}
                </span>
              </span>
            </span>
          ) : (
            <span className='text-nowrap'>
              {isNegative(row.original.sales_trend) ? (
                <i className='fa fa-arrow-down text-danger'></i>
              ) : row.original.sales_trend === 0 ? (
                <i className='fa fa-arrow-up text-primary'></i>
              ) : (
                <i className='fa fa-arrow-up text-success'></i>
              )}{' '}
              <span className='badge badge-light-success'>
                <span className='text-nowrap fs-7'>
                  {' '}
                  Net Sales: {addCommas(row.original.net_sales.toFixed(2))} {CURRENCY_APP}
                </span>
              </span>
            </span>
            
          )}
          </span>
              </div>
            </div>
          )
        },
      },
      {
        Header: 'E.Sales',
        accessor: 'date_end',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6'>
              {dayjs(value).format('LL')}
            </span>
            <span className='text-muted  text-nowrap fw-bold text-muted d-block fs-7'>
              {dayjs(value).format('dddd')}, {dayjs(value).format('LTS')}
              
            </span>
         
        </>
        ),
      },
      {
        Header: 'net_sales',
        accessor: 'net_sales',

      },
      {
        Header: 'sales_info',
        accessor: 'sales_info',

      },
      {
        Header: 'payment_totals',
        accessor: 'payment_totals',
      },
      {
        Header: 'total_expenses',
        accessor: 'total_expenses',
      },

       {
        Header: 'total_opening_float',
        accessor: 'total_opening_float',
      },

       {
        Header: 'total_closing_float',
        accessor: 'total_closing_float',
      },
      
      {
  Header: '',
  accessor: 'datesoldnow',
  Cell: ({ cell: { value }, row }) => (
    <button
      type='button'
      className='btn btn-sm btn-light-primary btn-icon'
      onClick={() => {
        setSelectedDateForModal(value)
        setSelectedRowData(row.original)
        handleShowDailySummary()
      }}
      title={`View summary for ${dayjs(value).format('MMM DD, YYYY')}`}
    >
      <span className='svg-icon svg-icon-4'>
        <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none'>
          <path d='M17.5 11H6.5C4 11 2 9 2 6.5C2 4 4 2 6.5 2H17.5C20 2 22 4 22 6.5C22 9 20 11 17.5 11ZM15 6.5C15 7.9 16.1 9 17.5 9C18.9 9 20 7.9 20 6.5C20 5.1 18.9 4 17.5 4C16.1 4 15 5.1 15 6.5Z' fill='currentColor'/>
          <path opacity='0.3' d='M17.5 22H6.5C4 22 2 20 2 17.5C2 15 4 13 6.5 13H17.5C20 13 22 15 22 17.5C22 20 20 22 17.5 22ZM4 17.5C4 18.9 5.1 20 6.5 20C7.9 20 9 18.9 9 17.5C9 16.1 7.9 15 6.5 15C5.1 15 4 16.1 4 17.5Z' fill='currentColor'/>
        </svg>
      </span>
    </button>
  ),
},
    ]

  const columndata4: ReadonlyArray<
    Column<{
      sales_id: number
      quantity: number
      unit_price: number
      sub_total: number
      product_id: number
      discount_percentage: number
      product_unit_id: number
      unit_name: string
      user_id: number
      sales_invoice_id: string
      datesold: string
      sales_status: string
      product_name: string
    }>
  > = [
      {
        Header: 'Product',
        accessor: 'product_id',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-primary text-nowrap  fw-bolder d-block mb-1 fs-6'>
              {truncate(row.original.product_name, 20)}

              <span className='h-10px border-gray-200 border-start mx-2'></span>
              <span>{row.original.quantity}</span>
            </span>

            <span className='text-muted  text-nowrap  fw-bold text-muted d-block fs-7'>
              {dayjs(row.original.datesold).calendar()}
              <span className='h-10px border-gray-200 border-start mx-2'></span>
              {addCommas(row.original.sub_total.toFixed(2))} {CURRENCY_APP}{' '}
            </span>
          </>
        ),
      },
    ]

  //less than 420

  //less than 730 but more than 420
  const columndata5: ReadonlyArray<
    Column<{
      datesoldnow: string
      date_start: string
      date_end: string
      occurrences: number
      hours_selling: number
      sales_tax: number
      net_sales: number
      gross_sales: number
      discount: number
      gross_deductions: number
      sales_trend: number
      payment_totals:Array<number | string>
      sales_info: Array<number | string>
      total_opening_float: number
      total_closing_float: number
      total_expenses: number
    }>
  > = [
      {
        Header: () => null,
        id: 'expander',

        Cell: ({ row }: any) => {
          return (
            <span {...row.getToggleRowExpandedProps()}>
              {row.isExpanded ? (
                <>
                  <span className='svg-icon svg-icon-primary'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      xmlnsXlink='http://www.w3.org/1999/xlink'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                    >
                      <g fill='none' fillRule='evenodd'>
                        <path d='M0 0L24 0 24 24 0 24z'></path>
                        <path
                          fill='#009ef7'
                          fillRule='nonzero'
                          d='M17.293 8.293a1 1 0 111.414 1.414l-6 6a1 1 0 01-1.383.03l-6-5.5a1 1 0 111.352-1.474l5.294 4.853 5.323-5.323z'
                        ></path>
                      </g>
                    </svg>
                  </span>
                </>
              ) : (
                <>
                  <span className='svg-icon svg-icon-primary'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      xmlnsXlink='http://www.w3.org/1999/xlink'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                    >
                      <g fill='none' fillRule='evenodd'>
                        <path d='M0 0L24 0 24 24 0 24z'></path>
                        <path
                          fill='#009ef7'
                          fillRule='nonzero'
                          d='M8.293 6.707a1 1 0 111.414-1.414l6 6a1 1 0 01.03 1.383l-5.5 6a1 1 0 11-1.474-1.352l4.853-5.294-5.323-5.323z'
                        ></path>
                      </g>
                    </svg>
                  </span>
                </>
              )}
            </span>
          )
        },
      },
      {
        Header: 'Date',
        accessor: 'date_start', // accessor is the "key" in the data

        Cell: ({ cell: { value }, row }) => {
          return (
            <div className='d-flex align-items-center'>
              <div className='symbol symbol-60px me-5'>
                <span className='svg-icon svg-icon-primary svg-icon-3x'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='20'
                    height='21'
                    fill='none'
                    viewBox='0 0 20 21'
                  >
                    <path
                      fill='currentColor'
                      d='M19 3.4c-.6 0-1 .4-1 1v4h-4v-4c0-.6-.4-1-1-1s-1 .4-1 1v4H8v-4c0-.6-.4-1-1-1s-1 .4-1 1v4H2v-4c0-.6-.4-1-1-1s-1 .4-1 1v15c0 .6.4 1 1 1h18c.6 0 1-.4 1-1v-15c0-.6-.4-1-1-1zm-1 7v3h-4v-3h4zm-6 0v3H8v-3h4zm0 5v3H8v-3h4zm-6-5v3H2v-3h4zm-4 5h4v3H2v-3zm12 3v-3h4v3h-4z'
                      opacity='0.3'
                    ></path>
                    <path
                      fill='currentColor'
                      d='M19 .4H1c-.6 0-1 .4-1 1v3c0 .6.4 1 1 1h18c.6 0 1-.4 1-1v-3c0-.6-.4-1-1-1z'
                    ></path>
                  </svg>
                </span>
              </div>

              <div className='d-flex justify-content-start flex-column'>
                <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6'>
                  {dayjs(value).format('MMMM')} {dayjs(value).format('DD')} -{' '}
                  {dayjs(row.original.date_end).format('DD')} , {dayjs(value).format('YYYY')}
                </span>
                <span className='text-muted  text-nowrap fw-bold text-muted d-block fs-7'>
                  {dayjs(value).format('LTS')} - {dayjs(row.original.date_end).format('LTS')}
                </span>
              </div>
            </div>
          )
        },
      },
      {
        Header: 'E.Sales',
        accessor: 'date_end',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6'>
              {dayjs(value).format('MMMM')} {dayjs(value).format('DD')} -{' '}
              {dayjs(row.original.date_end).format('DD')} , {dayjs(value).format('YYYY')}
            </span>
            <span className='text-muted  text-nowrap fw-bold text-muted d-block fs-7'>
              {dayjs(value).format('LTS')} - {dayjs(row.original.date_end).format('LTS')}
            </span>
          </>
        ),
      },
      {
        Header: 'Entries',
        accessor: 'occurrences',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6'>{value}</span>
            <span className='text-muted  text-nowrap fw-bold text-muted d-block fs-7'>
              {row.original.hours_selling} Hours
            </span>
          </>
        ),
      },

      {
        Header: 'G.Sales',
        accessor: 'gross_sales',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6'>
              <>
                {isNegative(value) ? (
                  <span className='text-danger'>
                    {addCommas(value.toFixed(2))} {CURRENCY_APP}
                  </span>
                ) : (
                  <span>
                    {addCommas(value.toFixed(2))} {CURRENCY_APP}{' '}
                  </span>
                )}
              </>
            </span>
            <span className='text-muted  text-nowrap fw-bold text-muted d-block fs-7'>
              <span className='badge badge-light-danger'>
                {addCommas(row.original.gross_deductions.toFixed(2))} {CURRENCY_APP}
              </span>
            </span>
          </>
        ),
      },
      
      {
        Header: 'sales_info',
        accessor: 'sales_info',

      },
      {
        Header: 'payment_totals',
        accessor: 'payment_totals',
      },
      {
        Header: 'total_expenses',
        accessor: 'total_expenses',
      },

       {
        Header: 'total_opening_float',
        accessor: 'total_opening_float',
      },

       {
        Header: 'total_closing_float',
        accessor: 'total_closing_float',
      },
      {
        Header: 'N.Sales',
        accessor: 'net_sales',

        Cell: ({ cell: { value }, row }) => (
          <>
            {isNegative(value) ? (
              <span className='text-nowrap'>
                {isNegative(row.original.sales_trend) ? (
                  <i className='fa fa-arrow-down text-danger'></i>
                ) : row.original.sales_trend === 0 ? (
                  <i className='fa fa-arrow-up text-primary'></i>
                ) : (
                  <i className='fa fa-arrow-up text-success'></i>
                )}{' '}
                <span className='badge badge-light-danger'>
                  <span className='text-nowrap fs-7'>
                    {' '}
                    {addCommas(value.toFixed(2))} {CURRENCY_APP}
                  </span>
                </span>
              </span>
            ) : (
              <span className='text-nowrap'>
                {isNegative(row.original.sales_trend) ? (
                  <i className='fa fa-arrow-down text-danger'></i>
                ) : row.original.sales_trend === 0 ? (
                  <i className='fa fa-arrow-up text-primary'></i>
                ) : (
                  <i className='fa fa-arrow-up text-success'></i>
                )}{' '}
                <span className='badge badge-light-success'>
                  <span className='text-nowrap fs-7'>
                    {' '}
                    {addCommas(value.toFixed(2))} {CURRENCY_APP}
                  </span>
                </span>
              </span>
            )}
          </>
        ),
      },
   {
  Header: '',
  accessor: 'datesoldnow',
  Cell: ({ cell: { value }, row }) => (
    <button
      type='button'
      className='btn btn-sm btn-light-primary'
      onClick={() => {
        setSelectedDateForModal(value)
        setSelectedRowData(row.original)
        handleShowDailySummary()
      }}
      title={`View summary for ${dayjs(value).format('MMMM DD, YYYY')}`}
    >
      <span className='svg-icon svg-icon-4 me-1'>
        <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none'>
          <path d='M17.5 11H6.5C4 11 2 9 2 6.5C2 4 4 2 6.5 2H17.5C20 2 22 4 22 6.5C22 9 20 11 17.5 11ZM15 6.5C15 7.9 16.1 9 17.5 9C18.9 9 20 7.9 20 6.5C20 5.1 18.9 4 17.5 4C16.1 4 15 5.1 15 6.5Z' fill='currentColor'/>
          <path opacity='0.3' d='M17.5 22H6.5C4 22 2 20 2 17.5C2 15 4 13 6.5 13H17.5C20 13 22 15 22 17.5C22 20 20 22 17.5 22ZM4 17.5C4 18.9 5.1 20 6.5 20C7.9 20 9 18.9 9 17.5C9 16.1 7.9 15 6.5 15C5.1 15 4 16.1 4 17.5Z' fill='currentColor'/>
        </svg>
      </span>
      View
    </button>
  ),
},
    ]
  const columndata6: ReadonlyArray<
    Column<{
      sales_id: number
      quantity: number
      unit_price: number
      sub_total: number
      product_id: number
      discount_percentage: number
      product_unit_id: number
      user_id: number
      sales_invoice_id: string
      datesold: string
      sales_status: string
      product_name: string
      unit_name: string
    }>
  > = [
      {
        Header: 'Product',
        accessor: 'product_id',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-primary text-nowrap  fw-bolder d-block mb-1 fs-6'>
              {truncate(row.original.product_name, 20)}
            </span>

            <span className='text-muted  text-nowrap  fw-bold text-muted d-block fs-7'>
              Product Id {value}
            </span>
          </>
        ),
      },

      {
        Header: 'Quantity',
        accessor: 'quantity',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-dark text-nowrap  fw-bolder d-block mb-1 fs-6'>{value}</span>
            <span className='text-muted  text-nowrap  fw-bold text-muted d-block fs-7'>
              {row.original.unit_name}
            </span>
          </>
        ),
      },

      {
        Header: 'Price',
        accessor: 'unit_price',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-dark text-nowrap  fw-bolder d-block mb-1 fs-6'>
              {addCommas(value.toFixed(2))} {CURRENCY_APP}
            </span>

            <span className='text-muted  text-nowrap  fw-bold text-muted d-block fs-7'>
              Deduction: {row.original.discount_percentage}%
            </span>
          </>
        ),
      },
      {
        Header: 'Total',
        accessor: 'sub_total',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-success text-nowrap  fw-bolder d-block mb-1 fs-6'>
              {addCommas(value.toFixed(2))} {CURRENCY_APP}
            </span>
          </>
        ),
      },
    ]

  //less than 730 but more than 420

  return (
    <>
      <LoadingBar color='#009ef7' ref={refloadingbar} />
      <PageTitle breadcrumbs={usersBreadcrumbs}>All Sales</PageTitle>
      {/* begin::Row */}
      {/* begin::Row */}
      {showDashboard && (
      <div className='row g-5 g-xl-8'>
        {/* begin::Col */}

        <div className='col-xl-4'>
          <ItemsSummary
            className='card-xl-stretch mb-xl-8'
            chartColor='primary'
            chartHeight='120px'
            cardName='G.Sales'
            chartName='Gross Sales'
            statusnow={statusnow}
            statusnow2={statusnow2}
            yaxisHeight={Math.abs(Math.max(...gross_sales))}
            chartCategories={gross_sales_date2}
            chartData={gross_sales2}
            values={
              <>
                <div className='fs-2 fw-bolder d-block '>
                  <CountUp
                    className='text-primary'
                    end={gross_sales[0]}
                    duration={2}
                    decimals={2}
                    separator=','
                  />{' '}
                  <sup className='fs-6 text-primary'>{CURRENCY_APP}</sup>
                </div>
              </>
            }
            values2={
              <>
                <span className='fw-bold d-block fs-7 mt-2 text-muted'>
                  <table>
                    <tbody>
                      {gross_sales[1] ? (
                        <tr>
                          <td>
                            <span className='badge badge-light-primary'>{gross_sales_date[1]}</span>
                          </td>
                          <td>
                            <span className='h-20px border-gray-200 border-start mx-2'></span>
                            <CountUp
                              className='text-bold text-muted'
                              end={gross_sales[1]}
                              duration={2}
                              decimals={2}
                              separator=','
                            />{' '}
                            <sup className='text-muted'>{CURRENCY_APP}</sup>
                          </td>
                        </tr>
                      ) : (
                        <></>
                      )}

                      {gross_sales[2] ? (
                        <tr>
                          <td>
                            <span className='badge badge-light-primary'>{gross_sales_date[2]}</span>
                          </td>
                          <td>
                            <span className='h-20px border-gray-200 border-start mx-2'></span>
                            <CountUp
                              className='text-bold text-muted'
                              end={gross_sales[2]}
                              duration={2}
                              decimals={2}
                              separator=','
                            />{' '}
                            <sup className='text-muted'>{CURRENCY_APP}</sup>
                          </td>
                        </tr>
                      ) : (
                        <></>
                      )}
                    </tbody>
                  </table>
                </span>
              </>
            }
          />
        </div>
        {/* end::Col */}

        {/* begin::Col */}
        <div className='col-xl-4'>
          <ItemsSummary
            className='card-xl-stretch mb-xl-8'
            chartColor='danger'
            chartHeight='120px'
            cardName='G.Deduct.'
            chartName='Gross Deductions'
            statusnow={statusnow}
            statusnow2={statusnow2}
            yaxisHeight={
              Math.abs(Math.max(...deductions_made))
            }
            chartCategories={discounts_made_date2}
            chartData={discounts_made2}
            values={
              <div className='fs-2 fw-bolder'>
                <CountUp
                  className='text-danger'
                  end={deductions_made[0]}
                  duration={2}
                  decimals={2}
                  separator=','
                />{' '}
                <sup className='text-danger fs-6'>{CURRENCY_APP}</sup>
              </div>
            }
            values2={
              <>
                <span className='fw-bold d-block fs-7 mt-2 text-muted'>
                  <table>
                    <tbody>
                      {deductions_made[1] ? (
                        <tr>
                          <td>
                            <span className='badge badge-light-danger'>
                              {discounts_made_date[1]}
                            </span>
                          </td>
                          <td>
                            <span className='h-20px border-gray-200 border-start mx-2'></span>
                            <CountUp
                              className='text-bold text-muted'
                              end={deductions_made[1]}
                              duration={2}
                              decimals={2}
                              separator=','
                            />{' '}
                            <sup className='text-muted'>{CURRENCY_APP}</sup>
                          </td>
                        </tr>
                      ) : (
                        <></>
                      )}

                      {deductions_made[2] ? (
                        <tr>
                          <td>
                            <span className='badge badge-light-danger'>
                              {discounts_made_date[2]}
                            </span>
                          </td>
                          <td>
                            <span className='h-20px border-gray-200 border-start mx-2'></span>
                            <CountUp
                              className='text-bold text-muted'
                              end={deductions_made[2]}
                              duration={2}
                              decimals={2}
                              separator=','
                            />{' '}
                            <sup className='text-muted'>{CURRENCY_APP}</sup>
                          </td>
                        </tr>
                      ) : (
                        <></>
                      )}
                    </tbody>
                  </table>
                </span>
              </>
            }
          />
        </div>
        {/* end::Col */}

        {/* begin::Col */}
        <div className='col-xl-4'>
          <ItemsSummary
            className='card-xl-stretch mb-5 mb-xl-8'
            chartColor={'success'}
            chartHeight='120px'
            statusnow={statusnow}
            statusnow2={statusnow2}
            cardName={'N.Sales'}
            chartName={'Net Sales'}
            yaxisHeight={
              Math.abs(Number(Math.max(...netsales).toFixed(0))) +
              Math.abs(Number(Math.min(...netsales).toFixed(0)))
            }
            chartCategories={sales_date2}
            chartData={netsales2}
            values={
              <>
                <div className='fs-2 fw-bolder'>
                  <CountUp
                    className={'text-success'}
                    end={netsales[0]}
                    duration={2}
                    decimals={2}
                    separator=','
                  />{' '}
                  <sup
                    className={`${isNegative(netsales[0]) ? 'fs-6 text-danger' : 'fs-6 text-success'
                      }`}
                  >
                    {CURRENCY_APP}
                  </sup>
                </div>
              </>
            }
            values2={
              <>
                <span className='fw-bold d-block fs-7 mt-2 text-muted'>
                  <table>
                    <tbody>
                      {netsales[1] ? (
                        <tr>
                          <td>
                            <span className={'badge badge-light-success'}>{sales_date[1]}</span>
                          </td>
                          <td>
                            <span className='h-20px border-gray-200 border-start mx-2'></span>
                            <CountUp
                              className='text-bold text-muted'
                              end={netsales[1]}
                              duration={2}
                              decimals={2}
                              separator=','
                            />{' '}
                            <sup className='text-muted'>{CURRENCY_APP}</sup>
                          </td>
                        </tr>
                      ) : (
                        <></>
                      )}

                      {netsales[2] ? (
                        <tr>
                          <td>
                            <span className={'badge badge-light-success'}>{sales_date[2]}</span>
                          </td>
                          <td>
                            <span className='h-20px border-gray-200 border-start mx-2'></span>
                            <CountUp
                              className='text-bold text-muted'
                              end={netsales[2]}
                              duration={2}
                              decimals={2}
                              separator=','
                            />{' '}
                            <sup className='text-muted'>{CURRENCY_APP}</sup>
                          </td>
                        </tr>
                      ) : (
                        <></>
                      )}
                    </tbody>
                  </table>
                </span>
              </>
            }
          />
        </div>
        {/* end::Col */}
      </div>)}
      {/* end::Row */}

       <KTCard>
        <KTCardBody className='py-4'>
          <div className='row mt-4'>
            <div className='col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'>
              <div className='mb-2'>
                <h3 className='fw-bolder my-2'>Daily Sales</h3>
              </div>
            </div>

            <div className='col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'>
              <div className='mb-2'>
                {/* begin::Search */}
                <div className='d-flex align-items-center position-relative my-1'>
                  <a href='#' onClick={handlesearchKeyDown2}>
                    <KTSVG
                      path='/media/icons/duotune/general/gen021.svg'
                      className='svg-icon-1 position-absolute me-4 top-0 end-0 mt-3 text-primary'
                    />
                  </a>
                  <input
                    type='text'
                    data-kt-user-table-filter='search'
                    className='form-control form-control-solid w-250px ps-14'
                    placeholder='Search Items'
                    ref={myRefsearch}
                    // value={searchTitle}
                    onChange={handleinputs}
                    onKeyDown={handlesearchKeyDown}
                  />
                </div>
                {/* end::Search */}
              </div>
            </div>
          </div>

          <div className='row mt-5 mb-5'>
            <div className='col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'></div>

            <div className='col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'>
              <div className='mb-2'>
                <div className='d-flex align-items-center text-nowrap'>
                  <span className='text-muted fw-bolder fs-7 text-uppercase gs-0'>INSIGHTS</span>
                  <span className='h-50px border-gray-200 border-start mx-2'></span>
                  <div className='d-flex justify-content-start flex-column'>
                    <span className='fw-bold d-block fs-7 text-muted'>
                      <table>
                        <tbody>
                          {salesTrend.direction ? (
                            <tr>
                              <td>NS.TREND</td>
                              <td>
                                <span className='h-20px border-gray-200 border-start mx-2'></span>
                                <span className={`${salesTrend.textColor}`}>
                                  <span className='text-uppercase text-bolder'>
                                    {salesTrend.direction}
                                  </span>{' '}
                                </span>
                              </td>
                            </tr>
                          ) : (
                            <></>
                          )}

                          {dailysalesssuccess2 ? (
                            <tr>
                              <td>NS.AVERAGE</td>
                              <td>
                                <span className='h-20px border-gray-200 border-start mx-2'></span>
                                <span className='text-uppercase text-bolder'>
                                  <CountUp
                                    className='text-primary'
                                    end={
                                      Number(
                                        tabledata3.reduce(
                                          (acc: any, curr: any) => acc + curr.net_sales,
                                          0
                                        )
                                      ) / tabledata3.length
                                    }
                                    duration={2}
                                    decimals={2}
                                    separator=','
                                  />{' '}
                                  <sup> {CURRENCY_APP}</sup>
                                </span>
                              </td>
                            </tr>
                          ) : (
                            <></>
                          )}
                        </tbody>
                      </table>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Maintable
            tabledata={dailysalesssuccess ? tabledata : []}
            startlimit={startlimit}
            hiddencolumnsmade={onlyWidth <= 576 ? hiddencolumnsmade2 : hiddencolumnsmade}
            movetofirstpage={movetofirstpage}
            setMovetofirstpage={setMovetofirstpage}
            setstartlimit={setStartlimit}
            paginationsize={paginationsize}
            pageCount={pageCount}
            setPageCount={setPageCount}
            setPaginationsize={setPaginationsize}
            columndata={
              onlyWidth <= 576
                ? columndata3
                : onlyWidth > 576 && onlyWidth <= 768
                ? columndata5
                : columndata1
            }
            tabledata2={tabledata2}
            columndata2={
              onlyWidth <= 576
                ? columndata4
                : onlyWidth > 576 && onlyWidth <= 768
                ? columndata6
                : columndata2
            }
            table1loaded={dailysalesstatus === 'success'}
            table2loaded={dailysalesstatus === 'success'}
            tablename={tablename}
            tablelength={dailysalesstatus === 'success' ? tabledatalength : 0}
            filteredsubdata={filteredsubdata}
            paymenttypedetails={paymenttypedetails}
            filteredtablesubData={filteredtablesubData}
            setServersort={setServersort}
          />
        </KTCardBody>
      </KTCard>
     {showDailySummary && (
  <Dailysummarymodal
    show={showDailySummary}
    handleClose={handleCloseDailySummary}
    selectedDate={selectedDateForModal}
    selectedRowData={selectedRowData} // Add this prop
    ref={myRefdailysummary}
  />
)}
    </>
  )
}

export default Home
